require('../modules/es6.object.to-string');
require('../modules/web.dom.iterable');
require('../modules/es6.weak-map');
require('../modules/es7.weak-map.of');
require('../modules/es7.weak-map.from');
module.exports = require('../modules/_core').WeakMap;



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/fn/weak-map.js
 ** module id = 914
 ** module chunks = 0
 **/